import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { DEFAULT_PAGE_SIZE } from 'data/constants';

function usePagination(navigate, searchParams) {
  const [, setSearchParams] = useSearchParams();

  const [paginationRequest, setPaginationRequest] = useState({
    pageNumber: searchParams.get('pageNumber') || 1,
    pageSize: searchParams.get('pageSize') || DEFAULT_PAGE_SIZE,
  });

  const [paginationResult, setPaginationResult] = useState({
    page: searchParams.get('pageNumber') || 1,
    pageSize: searchParams.get('pageSize') || DEFAULT_PAGE_SIZE,
    totalPages: 0,
    total: 0,
  });

  useEffect(() => {
    if (paginationRequest) {
      setSearchParams({
        pageNumber: paginationRequest.pageNumber,
        pageSize: paginationRequest.pageSize,
      });
    }
  }, [paginationRequest]);

  useEffect(() => {
    setPaginationRequest({
      pageNumber: searchParams.get('pageNumber') || 1,
      pageSize: searchParams.get('pageSize') || DEFAULT_PAGE_SIZE,
      totalPages: 0,
      total: 0
    });
  }, []);

  return {
    paginationRequest,
    setPaginationRequest,

    paginationResult,
    setPaginationResult
  };
}

export default usePagination;
